import lodash from 'lodash'
import React, { useMemo } from 'react'
import { ReactElement } from 'react'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { formatDecimal } from '../../../../../../../1stlog-ui/src/components/Field/format'
import InlineEditorInvalid from '../../../../../../../1stlog-ui/src/components/InlineEditor/InlineEditorInvalid'

type TTotalWeightProps = {
  readonly?: boolean
  tooltip?: string
}

const TotalWeight = (props: TTotalWeightProps): ReactElement => {
  const { readonly, tooltip } = props

  const colis = useField('colis')

  const value = useMemo(
    () =>
      lodash.sum(
        lodash.map(colis, (v) => parseFloat(lodash.get(v, 'weight', 0))),
      ),
    [colis],
  )

  return (
    <div className="text-center">
      <div>
        <Label tooltip={tooltip}>
          {i18n.t('total_weight', 'Gesamtgewicht')}
        </Label>
      </div>
      <h4 className={readonly ? 'mt-1' : 'mt-2'}>
        {isNaN(value) ? (
          <InlineEditorInvalid />
        ) : (
          <span>{formatDecimal(value, 2)} kg</span>
        )}
      </h4>
    </div>
  )
}

export default TotalWeight
